export function VusionLogo({ className }: { className?: string }) {
  return (
    <svg
      width="180"
      height="29"
      viewBox="0 0 180 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_487_1561)">
        <path
          d="M21.8369 15.9193V7.36719H25.9054V15.6313C25.9054 17.8095 26.8662 19.1552 28.788 19.1867C30.838 19.2193 31.7347 17.8737 31.7347 15.6313V7.36719H35.8032V15.9519C35.8032 19.7954 32.9521 22.8073 28.788 22.7747C24.3358 22.7421 21.8369 19.8921 21.8369 15.9193Z"
          fill="#0D2126"
        />
        <path
          d="M37.9209 17.9055H41.5089C41.7013 19.0587 42.9029 19.6033 44.0236 19.6033C45.1442 19.6033 45.9937 19.0587 45.9937 18.3218C45.9937 15.887 38.3057 17.3925 38.3057 11.5631C38.3057 9.06424 40.3883 7.04683 43.7828 7.04683C47.0828 7.01424 49.3241 8.77619 49.5491 11.7229H45.9611C45.8002 10.8262 44.9844 10.2175 43.8953 10.2175C42.8062 10.2175 42.0535 10.7936 42.0535 11.5631C42.0535 13.9012 49.8371 12.5566 49.8371 18.3218C49.8371 21.012 47.21 22.774 44.135 22.774C40.6437 22.774 38.1448 20.7555 37.9209 17.9044V17.9055Z"
          fill="#0D2126"
        />
        <path
          d="M51.8564 2.49784C51.8564 1.12066 53.0097 0 54.4184 0C55.8271 0 56.9488 1.12066 56.9488 2.49784C56.9488 3.87501 55.7956 4.96414 54.4184 4.96414C53.0412 4.96414 51.8564 3.87501 51.8564 2.49784ZM52.401 22.4217V7.36736H56.4369V22.4227H52.401V22.4217Z"
          fill="#0D2126"
        />
        <path
          d="M58.8096 14.8947C58.8096 10.4425 62.1737 7.04688 66.8498 7.04688C71.5258 7.04688 74.8899 10.4425 74.8899 14.8947C74.8899 19.3468 71.5269 22.7751 66.8498 22.7751C62.1726 22.7751 58.8096 19.3479 58.8096 14.8947ZM70.8856 14.8947C70.8856 12.3642 69.1878 10.5708 66.8498 10.5708C64.5117 10.5708 62.8139 12.3642 62.8139 14.8947C62.8139 17.4251 64.5117 19.2186 66.8498 19.2186C69.1878 19.2186 70.8856 17.4566 70.8856 14.8947Z"
          fill="#0D2126"
        />
        <path
          d="M76.9102 22.4228V13.8707C76.9102 9.89892 79.4407 7.04785 83.957 7.04785C88.4732 7.04785 90.9721 9.89892 90.9721 13.8707V22.4228H86.9363V14.1902C86.9363 11.9805 85.9428 10.6033 83.957 10.6033C81.9711 10.6033 80.9776 11.9805 80.9776 14.1902V22.4228H76.9092H76.9102Z"
          fill="#0D2126"
        />
        <path
          d="M21.803 0.576172L15.5384 22.4228H10.958L17.2226 0.576172H21.803Z"
          fill="#0D2126"
        />
        <path
          d="M6.26457 22.4228L0 0.576172H4.58042L10.845 22.4228H6.26457Z"
          fill="#0D2126"
        />
      </g>
      <defs>
        <clipPath id="clip0_487_1561">
          <rect width="180" height="28.7651" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
